module.exports = __webpack_public_path__ + "static/media/group_views.f89313fc.svg";